var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',[_c('label',{staticClass:"col-8"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"col-4 text-right"},[_vm._v(_vm._s(_vm.valueAsString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }